import { useCallback, useState } from "react";

import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import http from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useQuery } from "react-query";
import { TenantContaResponse } from "../typings";

function useGetContasBancarias({tenantId, incluirInativas}: {tenantId?: string, incluirInativas?: boolean}) {
  const { tenant } = useCurrentTenant();
  const [filtro, setFiltro] = useState<PaginateQuery>({
    page: 1,
    limit: 1000,
  });

  const _tenantId = tenantId || tenant.id;
  const onChangeFiltro = useCallback((prop, value?: any) => {
    if (prop === undefined) {
      setFiltro({ limit: BaseFiltroPaginate.Limit, page: 1 });
    } else if (typeof prop !== "string") {
      setFiltro((prev: any) => ({ ...prev, ...prop }));
    } else {
      setFiltro((prev: any) => ({ ...prev, [prop]: value }));
    }
  }, []);

  const queryResult = useQuery(
    [`/v1/tenants/${_tenantId}/conta-bancaria`, filtro],
    async () => {
      const { data } = await http.get<PaginateResult<TenantContaResponse>>(
        `/v1/tenants/${_tenantId}/conta-bancaria`,
        {
          params: {
            tenantId: _tenantId,
            ...filtro,
            incluirInativas: incluirInativas ? 1 : undefined
          },
        }
      );

      return data;
    }
  );

  return {
    ...queryResult,
    filtro,
    onChangeFiltro,
  };
}

export default useGetContasBancarias;
